import { Line, mixins } from 'vue-chartjs';
import chartMixin from './chartMixin';
export default {
  name: 'NiotaClassicChartsLine',
  extends: Line,
  mixins: [mixins.reactiveProp, chartMixin],
  props: {
    chartData: {
      type: Object,
      required: false,
      default: function () {
        return {};
      }
    },
    chartDataT: {
      type: Object,
      default: function () {
        return {};
      },
      required: false
    },
    multiChartDataT: {
      type: Object,
      default: function () {
        return {};
      },
      required: false
    },
    options: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  watch: {
    multiChartDataT: {
      handler: function () {
        this.updateLineChart();
      },
      deep: true
    },
    chartDataT: {
      handler: function () {
        this.updateLineChart();
      },
      deep: true
    }
  },
  mounted() {
    this.updateLineChart();
  },
  methods: {
    updateLineChart() {
      const mappedChartData = this.mapChartData();
      const chartOptions = this.chartOptions(this.options);
      this.renderChart({
        labels: mappedChartData.labels,
        datasets: mappedChartData.datasets
      }, chartOptions);
    },
    mapChartData() {
      if (this.multiChartDataT.individual) {
        return {
          datasets: this.multiChartDataT.individual.map((dataset, index) => {
            const color = (this.multiChartDataT.common || {}).color ? this.shadeColor(10 - index * 30, this.multiChartDataT.common.color || '#17bc00') : dataset.color;
            return {
              label: dataset.label,
              pointBackgroundColor: color,
              borderColor: color,
              backgroundColor: 'transparent',
              pointRadius: dataset.pointRadius !== undefined ? dataset.pointRadius : 1,
              pointHitRadius: dataset.pointHitRadius !== undefined ? dataset.pointHitRadius : undefined,
              borderWidth: 2,
              lineTension: 0.3,
              data: dataset.data
            };
          }),
          labels: (this.multiChartDataT.common || {}).labels
        };
      } else {
        const color = this.shadeColor(10, this.chartDataT.color || '#17bc00');
        return {
          labels: this.chartDataT.dataLabels,
          datasets: [{
            label: this.chartDataT.label,
            pointBackgroundColor: color,
            borderColor: color,
            backgroundColor: 'transparent',
            pointRadius: 1,
            borderWidth: 2,
            lineTension: 0.3,
            data: this.chartDataT.data
          }]
        };
      }
    }
  }
};